export default __webpack_public_path__ + "static/media/ticket-out.8193e5d6.png";